import { formatDateTimeBR } from '@/shared/utils/date-validator'
import DicomPlusHistorico from '../dicom-plus-historico/index.vue'

export default {
  name: 'ModalHistoricoExameGrid',
  components: { DicomPlusHistorico },

  props: {
    historico: {
      type: Array,
      default: () => []
    },
    detalhes: {
      type: Array,
      default: () => []
    },
    dicomPlusId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      itemDetalheFocado: null,
      mostrarDetalhes: false
    }
  },

  methods: {
    formatDate(date) {
      return formatDateTimeBR(date)
    },
    abrirDetalhe(item) {
      this.itemDetalheFocado = item
      this.mostrarDetalhes = true
    },
    fecharDetalhes() {
      this.mostrarDetalhes = false
      this.itemDetalheFocado = null
    },
    formatStatus(status) {
      const statusMap = {
        0: 'Disponível',
        1: 'Utilizado',
        99: 'Cancelado'
      }
      return statusMap[status] || 'Desconhecido'
    },
    formatBoolean(value) {
      if (value === null || value === undefined) return '-'
      return value ? this.$i18n.t('dicom_plus.yes') : this.$i18n.t('dicom_plus.no')
    },
    formatHistorySystem(item) {
      return item?.nameSystemOpen || item?.nameSystemUpdate || '-'
    },
    statusClass(status) {
      const normalizedStatus = String(status || '').toLowerCase()
      if (normalizedStatus.includes('pendente')) return 'status-pending'
      if (normalizedStatus.includes('cancel')) return 'status-canceled'
      if (normalizedStatus.includes('falha')) return 'status-error'
      if (normalizedStatus.includes('repetir')) return 'status-repeat'
      if (normalizedStatus.includes('aguardando') || normalizedStatus.includes('laudando')) return 'status-progress'
      if (normalizedStatus.includes('criado') || normalizedStatus.includes('liberado')) return 'status-success'
      return 'status-neutral'
    }
  }
}
